module.exports = __webpack_public_path__ + "static/pie5-6df7648ddeaa4b52e56c1b41d258b4c5.png";